import React from 'react'
import { PageContent, MapWidget, MapMenu, MapItem, MapLayer, MapOverlay, MapTabs, MapTab, MessageTooltip, Text } from 'components/library'
import { Layer } from 'components/library/widgets/map/components'
import { Slider } from 'content/components/slider/Slider'
import DropdownMix from 'content/components/dropdown/DropdownMix'
import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import layer01 from './assets/svg_3_3_1.svg'
import layer02 from './assets/svg_3_3_2.svg'
import layer03 from './assets/svg_3_3_3.svg'
import layer04 from './assets/svg_3_3_4.svg'
import layer1_4_1 from './assets/svg_3_3_3_1_1_1-01.svg'
import layer1_4_2 from './assets/svg_3_3_3_1_1_2-01.svg'
import layer1_4_3 from './assets/svg_3_3_3_1_1_3-01.svg'
import layer4_1_1 from './assets/svg_3_3_3_2_1_1-01.svg'
import layer4_1_2 from './assets/svg_3_3_3_2_1_2-01.svg'
import layer4_1_3 from './assets/svg_3_3_3_2_1_3-01.svg'
import './Aspect03.css'

class Aspect03 extends React.Component {
  state = {
    dropdownValue: [1,4],
    sliderValue: 0,
  }

  handleDropdownChange = value => {
    this.setState({
      dropdownValue: value,
      sliderValue: 0,
    })
    console.log(value)
  }

  handleSliderChange = value => {
    this.setState({ sliderValue: value })
    console.log(value)
  }

  checkValues = values => {
    return values.join(',') === this.state.dropdownValue.join(',')
  }

  render() {
    return (
      <div className="Chapter03-Aspect03">
        <PageContent nospacing>
          <MapWidget
            mapImage={mapBaseImage}
            height={800}
            mapBounds={[[0, 0], [3556, 3406]]}
            options={{ minZoom: -1.5 }}>
            <MapMenu>

              <MapItem center={[2905,838]} zoom={-0.3} label={'Uniform-platform'}>
                <MapOverlay>
                  <MessageTooltip>
                    <Text><strong>Uniform-platform</strong></Text>
                    <Text>Op het Uniform-platform moeten vliegtuigen zowel nose-in als nose-out geparkeerd worden. Op VOP U32, U26 en U23 dien je vliegtuigen nose-out te parkeren. Op de overige VOP's parkeer je de vliegtuigen nose-in.</Text>
                  </MessageTooltip>
                </MapOverlay>
                <MapLayer>
                  <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
                </MapLayer>
              </MapItem>

              <MapItem center={[1927,3042]} zoom={0.5} label={'Hangar 4 en Hangar 32'}>
                <MapTabs>

                  <MapTab visible center={[1927,3042]} zoom={0.5} label="Hangar 4 en Hangar 32" showText={
                    <div>
                      <Text>Op Rijbaan GL geldt een wingspanrestrictie van 52 meter. Indien je een vliegtuig naar Hangar 4 of Hangar 32 moet slepen met een wingspan groter dan 52 meter gelden de volgende voorwaarden:</Text>
                    </div>
                  }>
                    <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
                  </MapTab>

                  <MapTab center={[1904,3088]} zoom={1} label="Wing walker" showText={
                    <div>
                      <Text>Je afhandelaar levert minimaal twee wingwalkers die in het bezit zijn van een sleep- en/of veldbevoegdheid. De wingwalkers lopen tijdens het slepen mee tussen de maximale wingspan markering op rijbaan GL en Hangar 4 danwel Hangar 32.</Text>
                    </div>
                  }>
                    <Layer url={layer02} bounds={[[0, 0], [3556, 3406]]} />
                  </MapTab>

                  <MapTab center={[1922,3100]} zoom={1} label="VOP K35" showText={
                    <div>
                      <Text>VOP K35 is vrij van geparkeerde vliegtuigen, waarvoor je afhandelaar voor aanvang van versleping afstemt met het Jetcenter</Text>
                    </div>
                  }>
                    <Layer url={layer03} bounds={[[0, 0], [3556, 3406]]} />
                  </MapTab>

                  <MapTab center={[1927,3042]} zoom={0.5} label="Schade" showText={
                    <div>
                      <Text>Indien er schade ontstaat aan de infrastructuur of het vliegtuig is dit voor het eigen risico van de afhandelaar.</Text>
                    </div>
                  }>
                    <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
                  </MapTab>

                </MapTabs>
              </MapItem>

              <MapItem label={'Kilo-platform'}>
                <MapOverlay>
                  <DropdownMix
                    value={this.state.dropdownValue}
                    options={[
                      { value: 1, label: 'Schiphol-Oost' },
                      { value: 4, label: 'Schiphol-Centrum' },
                    ]} onChange={this.handleDropdownChange} />

                  <br />

                  {this.checkValues([1,4]) &&
                    <Slider onChange={this.handleSliderChange}>
                      <div>
                        <Text><strong>Algemeen</strong></Text>
                        <Text>Het Kilo-platform is een zakenterrein en hoort officieel niet bij Airside. Doordat het platform geen onderdeel uitmaakt van Airside gelden er exta beveiligingsregels. Als je gebruik maakt van de Noordelijke trekkerroute, kom je over het platform. Het is daarom belangrijk dat je de procedure kent voor het betreden van het platform.</Text>
                      </div>
                      <div>
                        <Text><strong>Stap 1</strong></Text>
                        <Text>Je meldt je ter hoogte van Hek 3 aan bij Security, om het beveiligde gebied te betreden. Je meldt via de portofoon aan op het kanaal van SCC (dit staat als standaard in de portofoon als Kanaal 76513) of telefonisch op 020-601 3355.</Text>
                      </div>
                      <div>
                        <Text><strong>Stap 2</strong></Text>
                        <Text>Als je toestemming hebt gekregen kun je het Kilo-platform betreden en de Noordelijke trekkerroute vervolgen. Je moet aan één stuk doorrijden en mag alleen stil gaan staan op het platform zolang security je kan zien op de camera.</Text>
                      </div>
                      <div>
                        <Text><strong>Stap 3</strong></Text>
                        <Text>Voor het verlaten van het Kilo-platform moet je je weer afmelden bij Security om het beveiligde gebied te verlaten. Dit doe je via de telefoon of protofoon op het kanaal van SCC. Het is toegestaan even stil te staan om contact op te kunnen nemen met Security.</Text>
                      </div>
                    </Slider>
                  }

                  {this.checkValues([4,1]) &&
                    <Slider onChange={this.handleSliderChange}>
                      <div>
                        <Text><strong>Algemeen</strong></Text>
                        <Text>Het Kilo-platform is een zakenterrein en hoort officieel niet bij Airside. Doordat het platform geen onderdeel uitmaakt van Airside gelden er exta beveiligingsregels. Als je gebruik maakt van de Noordelijke trekkerroute, kom je over het platform. Het is daarom belangrijk dat je de procedure kent voor het betreden van het platform.</Text>
                      </div>
                      <div>
                        <Text><strong>Stap 1</strong></Text>
                        <Text>Je meldt je ter hoogte van Hangar 1 aan bij Security om het beveiligde gebied te betreden. Je meldt je via de portofoon aan op het kanaal van SCC (dit staat als standaard in de portofoon als Kanaal 76513) of telefonisch op 020-601 3355.  Het is toegestaan even stil te staan om met Security contact op te kunnen nemen.</Text>
                      </div>
                      <div>
                        <Text><strong>Stap 2</strong></Text>
                        <Text>Als je toestemming hebt gekregen kun je het Kilo-platform betreden en de Noordelijke trekkerroute vervolgen. Je moet aan één stuk doorrijden en mag alleen stil gaan staan op het platform zolang security je kan zien op de camera.</Text>
                      </div>
                      <div>
                        <Text><strong>Stap 3</strong></Text>
                        <Text>Ter hoogte van Hek 3 moet je je weer afmelden bij Security om het beveiligde gebied te verlaten. Dit doe je via de telefoon of portofoon op het kanaal van SCC.</Text>
                      </div>
                    </Slider>
                  }
                </MapOverlay>

                <MapLayer>
                  {this.checkValues([1,4]) && (this.state.sliderValue === 0 || this.state.sliderValue === 1) &&
                    <Layer
                      url={layer1_4_1}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2113,2802]}
                      zoom={-0.4} />
                  }

                  {this.checkValues([1,4]) && this.state.sliderValue === 2 &&
                    <Layer
                      url={layer1_4_2}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2113,2802]}
                      zoom={-0.4} />
                  }

                  {this.checkValues([1,4]) && this.state.sliderValue === 3 &&
                    <Layer
                      url={layer1_4_3}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2113,2802]}
                      zoom={-0.4} />
                  }

                  {this.checkValues([4,1]) && (this.state.sliderValue === 0 || this.state.sliderValue === 1) &&
                    <Layer
                      url={layer4_1_1}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2113,2802]}
                      zoom={-0.4} />
                  }

                  {this.checkValues([4,1]) && this.state.sliderValue === 2 &&
                    <Layer
                      url={layer4_1_2}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2113,2802]}
                      zoom={-0.4} />
                  }

                  {this.checkValues([4,1]) && this.state.sliderValue === 3 &&
                    <Layer
                      url={layer4_1_3}
                      bounds={[[0, 0], [3556, 3406]]}
                      center={[2113,2802]}
                      zoom={-0.4} />
                  }
                </MapLayer>
              </MapItem>

              <MapItem center={[2010,771]} zoom={0.1} label={'Juliett-platform'}>
                <MapOverlay>
                  <MessageTooltip>
                    <Text>Op het Juliett-platform vindt het de-icing proces plaats. In winterse omstandigheden kan het daarom voorkomen dat je vliegtuigen van en naar het Juliett-platform moet slepen.<br/><br/>Indien je van het Juliett-platform naar een volgende bestemming gaat slepen, dien je altijd uit te slepen via de de-icingspots.<br/><br/>Als je naar het platform toe sleept, zal je route bepaald worden door Apron Control. Zij zullen met LVNL en KLM De-icing het verkeer voor rijbaan A20 coördineren.</Text>
                  </MessageTooltip>
                </MapOverlay>
                <MapLayer>
                  <Layer url={layer04} bounds={[[0, 0], [3556, 3406]]} />
                </MapLayer>
              </MapItem>
            </MapMenu>
          </MapWidget>
        </PageContent>
      </div>
    )
  }
}

export default Aspect03



// WEBPACK FOOTER //
// ./src/content/chapters/03/03/Aspect03.js